import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import StepComponent from './Step'
import HandleNavigation from './HandleNavigation'

const Navbar = () => {

  const navigate = useNavigate()

  const handleNavigation = () => {
    navigate('/accessories')
  }

  return (
    <div>
      <section className="page-banner">
        <div className="container">
          <div className="d-flex">
            <div className="m-auto">
              <div className="breadcrumbss">
                <StepComponent
                  // step={}
                />
                {/* <Link to="/essence">
                  <div className="breadcrumb-item active">Essence</div>
                </Link>
                <Link to='/structure'>
                  <div className="breadcrumb-item">Structure</div>
                </Link>
                <Link to="/accessories">  
                  <div className="breadcrumb-item">Accessoires</div>
                </Link>
                <Link to="/finalization">
                  <div className="breadcrumb-item">Finalisation</div>
                </Link> */}
              </div>
              <div className="title">
                <h2 className="">Choisissez votre essence de bois</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>  
  )
}

export default Navbar